// Shared route patterns. react-router v7 does not support mid-segment params
// (e.g. /sell-:slug-gift-card), so we match this URL via a catch-all + regex.
export const SELL_BRAND_RE = /^\/sell-([a-z0-9-]+)-gift-card\/?$/;
